import { useSyncExternalStore } from 'react';
import { suscribirVersionNueva, versionNuevaDisponible } from '../pwa/registrarServiceWorker';
import { puedeInstalarseDirecto, suscribirInstalacion } from '../pwa/instalacionApp';

const suscribirConexion = (fn) => {
    window.addEventListener('online', fn);
    window.addEventListener('offline', fn);
    return () => {
        window.removeEventListener('online', fn);
        window.removeEventListener('offline', fn);
    };
};

// true cuando el dispositivo no tiene internet
export const useSinConexion = () => useSyncExternalStore(suscribirConexion, () => !navigator.onLine);

// true cuando hay una versión nueva de la app lista para activarse
export const useVersionNueva = () => useSyncExternalStore(suscribirVersionNueva, versionNuevaDisponible);

// true cuando el navegador permite mostrar el diálogo de instalación directo
export const usePuedeInstalarse = () => useSyncExternalStore(suscribirInstalacion, puedeInstalarseDirecto);
